export default "__VITE_ASSET__CGVAFcdu__"